// src/components/Pulse/InstructionModal.js
import React from 'react';
import './InstructionModal.css';

export default function InstructionModal({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>🎧 How Pulse Works</h2>
        <p>This is your customizable audio visualizer. Here’s how to use it:</p>

        <ol>
          <li>
            🔗 <strong>To load a YouTube video:</strong> paste the full video URL into the input box, click <em>“Load YouTube Audio”</em>, then press <em>Play</em>.
          </li>
          <li>
            🎼 <strong>To use a preset track:</strong> choose one from the dropdown list and press <em>Play</em>.
          </li>
          <li>
            🌀 <strong>Visualizer:</strong> choose between styles like pulse, bars, waves, dots, and more.
          </li>
          <li>
            👁️ <strong>Toggle animation:</strong> turn the visualizer on or off with the checkbox.
          </li>
        </ol>

        <hr style={{ margin: '20px 0', opacity: 0.3 }} />

        <h3>About This App</h3>
        <p>
          I built <strong>ProdPilot</strong> to help creators and freelancers like myself
          find focus through sound. I personally use this to stay in flow while working.
        </p>
        <p>
          Pulse is more than an audio visualizer — it’s part of a bigger idea:
          making tools that are both useful and fun.
        </p>
        <p>
          If you enjoy using this, consider <a href="https://buymeacoffee.com/prodpilot" target="_blank" rel="noopener noreferrer" className="inline-coffee-link">buying me a coffee</a> ☕ — it really helps support future updates.
        </p>

        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
